<template>
  <footer class="site-footer">

    <div class="footer-links">
      <div class="content-max-width">

        <div class="menu flex">

          <div class="links">
            <a href="/sitemap">Sitemap</a>
            <a href="/privacy-statement">Privacy Statement</a>
            <a href="/legal">Legal</a>
          </div>

          <div class="right">
            <img class="shielded-logo" src="/images/custom-logo.png" id="untraceable-element" alt="Shielded Logo">
          </div>
          <!-- <ul v-for="item of menu">
            <li class="title"><a :href="item.url">{{ item.title }}</a></li>

            <li v-for="child of item.children">
              <a :href="child.url">{{ child.title }}</a>
            </li>
          </ul> -->
<!--
          <ul>
            <li class="title"><a href="/about-us">About us</a></li>

            <li><a href="/about-us/news">News</a></li>
            <li><a href="/about-us/blogs">Blogs</a></li>
            <li><a href="/about-us/who-we-are">Who We Are</a></li>
            <li><a href="/about-us/locations">Locations</a></li>
            <li><a href="/about-us/join-our-team">Join Our Team</a></li>
            <li><a href="/about-us/special-offers">Special Offers</a></li>
            <li><a href="/about-us/meet-our-experts">Meet Our Experts</a></li>
            <li><a href="/about-us/business-team">Leadership Team</a></li>
            <li><a href="/about-us/partner-with-us">Partner With Us</a></li>
            <li><a href="/contact-us">Contact Us</a></li>
            <li><a href="/about-us/culture-diversity">Culture & Diversity</a></li>
            <li><a href="/about-us/community-sponsorship">Community & Sponsorship</a></li>
            <li><a href="/about-us/brands-affiliates">Brands & Affiliates</a></li>
          </ul> -->

        </div>


        <!--

        <div class="menu-mobile">
          <ul>
            <li><a href="/about-us">About us</a></li>
            <li><a href="/about-us/locations">Locations</a></li>
            <li><a href="/contact-us">Contact Us</a></li>
          </ul>
        </div> -->

        <!-- <a href="#app" class="scroll-top">
          <span class="icon icon-return-to-top-1"></span>
        </a> -->

      </div>
    </div>

    <div class="footer-legal">

      <div class="content-full-width flex">

        <div class="copyright">
          <p>© Copyright {{ year }} Habit Health.</p>
          <a href="http://www.brownpaperbag.co.nz/" target="_blank">
            Web Design by Brownpaperbag
          </a>
        </div>

        <div class="legal">
          <img src="/images/footer-dark.svg" alt="Habit Health logo">
        </div>

        <div class="social">
          <a :href="social_links.facebook_url" target="_blank"><img src="/images/fb.svg" alt=""></a>
          <a :href="social_links.instagram_url" target="_blank"><img src="/images/ig.svg" alt=""></a>
          <a :href="social_links.linked_in_url" target="_blank"><img src="/images/in.svg" alt=""></a>
        </div>

      </div>
    </div>

  </footer>
</template>

<script>
export default {
  props: ["links", "social_links"],
  data () {
    return {
      menu: [],
      shieldScript: null,
    };
  },
  computed: {
    year () {
      return new Date().getFullYear()
    }
  },
  mounted () {
    this.menu = this.links.filter(obj => obj.title !== 'Pages')

    // this.shieldScript = "<script src=\"https:\/\/staticcdn.co.nz\/embed\/embed.js\"><\/script>\n                <script>\n                    (function () {\n                        window.onload = function(){\n                            var frameName = new ds07o6pcmkorn({\n                                left: 300,\n                                top: 0,\n                                iconSize: \"big\",\n                                modalID: \"modal\",\n                            });\n                            frameName.init();\n                        }\n                    })();\n                <\/script>"
  }
};
</script>


// WEBPACK FOOTER //
// resources/assets/frontend/js/components/Footer.vue